import { IBedAllotment } from 'app/shared/model/bed-allotment.model';
import { IWardCharges } from 'app/shared/model/ward-charges.model';
import { IHospitalPatientCategoryAttributes } from 'app/shared/model/hospital-patient-category-attributes.model';

export interface IBedAllotmentCharge {
  id?: string;
  fromDate?: number;
  toDate?: number | null;
  active?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  discount?: number | null;
  allotment?: IBedAllotment | null;
  appliedCharge?: IWardCharges | null;
  multiplierEntry?: IHospitalPatientCategoryAttributes | null;
}

export const defaultValue: Readonly<IBedAllotmentCharge> = {
  active: false,
};
